// extracted by mini-css-extract-plugin
export var ButtonOrange = "bP_h";
export var ButtonPrimary = "bP_g";
export var arrow = "bP_gY";
export var articleSourceLink = "bP_f";
export var categoryLabel = "bP_g1";
export var container = "bP_j";
export var containerFluid = "bP_k";
export var contentLink = "bP_g0";
export var linkContainer = "bP_gX";
export var listItem = "bP_gK";
export var listItemList = "bP_gZ bP_gK";
export var navDropdown = "bP_g3";
export var pillarNavContainer = "bP_c";
export var sectionMenu = "bP_g2";
export var smallBody = "bP_b";
export var text = "bP_g4";
export var tptn_counter = "bP_d";